import React, { useState } from 'react';
import Auth from '../services/AuthService'
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";

function Login() {
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const login = (e) => {
    e.preventDefault();
    Auth.login(user, password)
      .then(() => {
        setUser('');
        setPassword('');
        navigate('/hjem', { replace: true });
      })
      .catch(function (err) {
        alert("There's an error logging in");
        console.log("Error logging in", err);
      });
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md mx-auto login center-block text-center">
          <div className="card offset-md-4 col-md-4">
            <div className="card-body">
              <h2>Log på</h2>
              <form>
                <div className="form-group">
                  <input type="text" value={user} onChange={(event) => setUser(event.target.value)} className="form-control" id="username" placeholder="Brugernavn" />
                </div>
                <div className="form-group">
                  <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} className="form-control" id="password" placeholder="Adgangskode" />
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={login}>Log på</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function mapStateToProps(state) {
  const { _user, _jwt } = state.login
  return { _user, _jwt };
}

export default connect(mapStateToProps)(Login)